import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const joinsSlice = createSlice({
    name: "joins",
    initialState,
    reducers: {
        resetJoin: () => [],
        addJoin: (state, { payload }) => { state.push({ position: payload, count: 1, conditions: []}) },
        addJoinColumn: (state, { payload }) => {
            state[payload].count++
        },
        deleteJoinColumn: (state, { payload }) => {
            state[payload].count--
        },
        deleteJoin: (state, { payload }) => {
            return state.filter((_, i) => i !== payload);
        },
        offSetJoin: (state, { payload }) => {
            state.forEach((el) => {
                const { position } = el;

                if (position[0] > payload) {
                    position[0]--;
                }
                if (position[1] > payload) {
                    position[1]--;
                }
            });
        },
        AddConditions: (state, { payload }) => {
            const { conditions, index } = payload;
            state[index].conditions = conditions;
        }
    }
})
export const { resetJoin, addJoin, addJoinColumn, deleteJoinColumn, deleteJoin, offSetJoin, AddConditions } = joinsSlice.actions

export default joinsSlice.reducer